var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amo_form_box"},[_c('div',{staticClass:"amo_form_title"},[_vm._v("Оставить заявку")]),_c('div',{staticClass:"amo_form_container",attrs:{"id":"amoforms"}})])
}]

export { render, staticRenderFns }